const headLinkData = {
  covomo: {
    id: "meta-link",
    rel: "icon",
    href: "/covomo.png",
    type: "image/png",
  },
  embedded: {
    id: "meta-link",
    rel: "icon",
    href: "",
    type: "image/png",
  },
  covomo_tariff_manager: {
    id: "meta-link",
    rel: "icon",
    href: "",
    type: "image/png",
  },
  covomo_portal_search: {
    id: "meta-link",
    rel: "icon",
    href: "",
    type: "image/png",
  },
};
export default headLinkData;
